import { setGuestNewsForm } from '@/app/globalRedux/guestNewsForm/GuestNewsFormSlice'
import { useDispatch } from 'react-redux'
import { useTranslation } from '@/app/i18n/client'
interface ToggleNewsType {
  newsModeValue: string
  requestCallBackValue?: boolean
}

const ToggleNews = ({ newsModeValue }: ToggleNewsType) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  return (
    <div className="relative w-full flex justify-center mb-6">
      <div className="relative flex border-b border-gray-300 mx-4 justify-evenly w-full">
        {['Send a news', 'To be called by phone'].map((option) => {
          const selected = newsModeValue === option
          const isCallBack = option === 'To be called by phone'

          return (
            <button
              key={option}
              onClick={() =>
                dispatch(
                  setGuestNewsForm({
                    newsMode: option,
                    requestCallBack: isCallBack,
                  })
                )
              }
              className={`relative px-5 py-3 text-[15px] capitalize font-medium transition-all duration-300 ease-in-out
            ${
              selected
                ? 'text-yellow-900'
                : 'text-gray-500 hover:text-yellow-800'
            }`}
            >
              {t(option)}
              {selected && (
                <span className="absolute left-0 bottom-0 h-0.5 w-full bg-yellow-600 rounded-full transition-all duration-300 ease-in-out" />
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default ToggleNews
